import React, {useEffect, useState} from 'react';
import {BoxTitle} from "../../../components/admin/BoxTitle";
import {useParams} from "react-router-dom";
import {ApiService} from "../../../service/ApiService";
import {participantResultType} from "../../../types/Api/ParticipantResultType";
import {participantHydrator} from "../../../models/hydrator/participantHydrator";
import {participant} from "../../../models/participant";
import {Loader} from "../../../components/admin/Loader";
import {ParticipantForm} from "../../../components/admin/participant/ParticipantForm";
import {RaceCard} from "../../../components/admin/race/RaceCard";

export const Edit = () => {
  const uuid: undefined | string = useParams().uuid;

  const [participant, setParticipant] = useState(undefined as undefined | participant);
  const [loading, setLoading] = useState(false);


  useEffect(() => {
    if (uuid) {
      const result = ApiService.get(`/participant/${uuid}`) as Promise<participantResultType>;

      setLoading(true);

      result
        .then((r) => {
          setParticipant(participantHydrator.hydrate(r));
        })
        .catch(() => {
          alert("Une erreur c'est produite.")
        })
        .finally(() => {
          setLoading(false);
        });
    }

  }, [uuid]);

  return (
    <>
      {loading && (
        <Loader/>
      )}

      {(!loading && participant && participant.race) && (
        <>
          <BoxTitle title="Modifier une sortie"/>
          <RaceCard race={participant.race} />
          <ParticipantForm participant={participant} race={participant.race} />
        </>
      )}
    </>
  )
}
